import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  FIND_USER_SUBPASS,
  RESET_SUBPASS,
  FETCH_RESET_SUBPASS_LOG,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';
import { IUsername } from '@/interface/SecretPassword';

@Module({ name: 'secretpassword' })
export default class SecretPassword extends VuexModule {
  @Action
  FindUser(username: string) {
    return Vue.axios({
      url: BASE_URL + FIND_USER_SUBPASS,
      method: M_POST,
      data: username,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  ResetSubPassword(username: IUsername) {
    return Vue.axios({
      url: BASE_URL + RESET_SUBPASS,
      method: M_POST,
      data: username,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  FecthResetSubPassLog(username: IUsername) {
    return Vue.axios({
      url: BASE_URL + FETCH_RESET_SUBPASS_LOG,
      method: M_POST,
      data: username,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }
}
